import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstPartaIngreso= () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_parte_ingreso', 
        name: 'Listado Parte Ingreso', 
        component: ViewLstPartaIngreso,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
